import { render, staticRenderFns } from "./channels-demo.vue?vue&type=template&id=4ea9c0dd&"
import script from "./channels-demo.vue?vue&type=script&lang=ts&"
export * from "./channels-demo.vue?vue&type=script&lang=ts&"
import style0 from "./channels-demo.vue?vue&type=style&index=0&id=4ea9c0dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports